/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupscolumnprovider2Inputs */

const en_signupscolumnprovider2 = /** @type {(inputs: Signupscolumnprovider2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed up via`)
};

const de_signupscolumnprovider2 = /** @type {(inputs: Signupscolumnprovider2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registriert über`)
};

/**
* | output |
* | --- |
* | "Signed up via" |
*
* @param {Signupscolumnprovider2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupscolumnprovider2 = /** @type {((inputs?: Signupscolumnprovider2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupscolumnprovider2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupscolumnprovider2(inputs)
	return de_signupscolumnprovider2(inputs)
});
export { signupscolumnprovider2 as "signupsColumnProvider" }